<div class="modal fade" id="{{copyRoundFormId}}" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered ">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title">Copy Round</h6>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="border border-rounded mb-2 table-responsive" style="height: 200px;">
                        <table class="table table-sm table-bordered scrollable">
                            <thead class="thead-light sticky-top">
                                <tr class="thead">
                                    <th>Loc</th>
                                    <th>Origin Customer</th>
                                    <th>Origin</th>
                                    <th>Origin City</th>
                                    <th>Dest Customer</th>
                                    <th>Destination</th>
                                    <th>Dest City</th>
                                    <th>Comm</th>
                                    <th>Loads</th>
                                    <th>Orign Load #</th>
                                    <th>Dest Unload #</th>
                                    <th>Rate</th>
                                    <th>Trucker</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let dispatch of round.dispatches; let i = index">
                                    <td>{{dispatch.locCode}}</td>
                                    <td>{{dispatch.customerName}}</td>
                                    <td>{{dispatch.originName}}</td>
                                    <td>{{dispatch.originCity}}</td>
                                    <td>{{dispatch.destinationCustomerName}}</td>
                                    <td>{{dispatch.destinationName}}</td>
                                    <td>{{dispatch.destinationCity}}</td>
                                    <td>{{dispatch.commodityCode}}</td>
                                    <td>
                                        <input type="number" min="1" class="form-control form-control-sm bg-yellow" name="dispatchLoads" [(ngModel)]="dispatch.loads" style="width: 70px;" />
                                        <span *ngIf="+dispatch.loads <= 0" class="text-danger">
                                            Loads must be greater than 0
                                        </span>
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control form-control-sm bg-yellow" name="dispatchOrignLoad" [(ngModel)]="dispatch.loadNumber" />
                                            <span class="input-group-text p-0 ps-1 pe-1">
                                                <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal" attr.data-bs-target="#{{loadBankApplyFormId}}"
                                                   title="find load number" (click)="openLoadBank(0, dispatch, i)">
                                                    <i class="fa-regular fa-rectangle-list"></i>
                                                </a>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="input-group">
                                            <input type="text" class="form-control form-control-sm bg-yellow" name="dispatchDestUnload" [(ngModel)]="dispatch.unloadNumber" />
                                            <span class="input-group-text p-0 ps-1 pe-1">
                                                <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal" attr.data-bs-target="#{{loadBankApplyFormId}}"
                                                   title="find load number" (click)="openLoadBank(1, dispatch, i)">
                                                    <i class="fa-regular fa-rectangle-list"></i>
                                                </a>
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="text" class="form-control form-control-sm bg-yellow" name="dispatchRate" [(ngModel)]="dispatch.rate" style="width: 100px;" />
                                    </td>
                                    <td>{{dispatch.truckerName}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row g-2 mb-2">
                        <div class="col-sm-3">
                            <label class="form-label">Round Notes</label>
                            <textarea class="form-control form-control-sm" id="roundNotes" name="roundNotes" rows="4" [(ngModel)]="round.notes"></textarea>
                        </div>

                        <div class="col-sm-3">
                            <label class="form-label">Internal Comments</label>
                            <textarea class="form-control form-control-sm" id="roundComments" name="roundComments" rows="4" [(ngModel)]="round.internalComments"></textarea>
                        </div>
                        <div class="col-sm-4 position-relative">
                            <div #truckerSearchDropdown class="row g-1">
                                <div class="col-sm-3">
                                    <label class="form-label">Trucker</label>
                                    <button class="btn btn-sm btn-secondary dropdown-toggle w-100" type="button" (click)="toggleTruckerSearch()">
                                        Select Trucker
                                    </button>
                                    <div *ngIf="showTruckerSearch">
                                        <div class="dropdown-search table-responsive border rounded shadow px-1">
                                            <table class="table table-sm table-borderless table-hover scrollable">
                                                <thead>
                                                    <tr [formGroup]="truckerSearchForm">
                                                        <th style="width: 45%;">
                                                            Trucker
                                                            <input type="text" class="form-control form-control-sm" formControlName="customerName" />
                                                        </th>
                                                        <th style="width: 35%;">
                                                            City
                                                            <input type="text" class="form-control form-control-sm" formControlName="city" />
                                                        </th>
                                                        <th style="width: 20%;">
                                                            Code
                                                            <input type="text" class="form-control form-control-sm" formControlName="customerCode" />
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of truckerList" (click)="selectTrucker(item)">
                                                        <td>{{item.customerName}}</td>
                                                        <td>{{item.city}}</td>
                                                        <td>{{item.customerCode}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-7">
                                    <label class="form-label">&nbsp;</label>
                                    <input type="text" class="form-control form-control-sm" id="trucker" name="trucker" placeholder="Trucker" disabled [value]="round.truckerName" [class.border-danger]="formState.trucker.invalid" />
                                    <div *ngIf="formState.trucker.invalid" class="text-danger">
                                        {{formState.trucker.errorMessage}}
                                    </div>
                                </div>
                            </div>

                            <div class="row g-1">
                                <div class="col-4">
                                    <label class="form-label">Copy to Period</label>
                                    <select name="planPeriod" class="form-select form-select-sm" (change)="planPeriodChange()" [(ngModel)]="roundParameters.planPeriod">
                                        <option *ngFor="let item of planPeriods; trackBy: trackPlanPeriod" [value]="item.value">
                                            {{item.text}}
                                        </option>
                                    </select>
                                </div>

                                <div class="col-6">
                                    <div class="row g-1">
                                        <div class="col-6">
                                            <label class="form-label">&nbsp;</label>
                                            <input type="date" name="planStartDate" class="form-control form-control-sm" [(ngModel)]="roundParameters.periodStartDate" [attr.disabled]="roundParameters.planPeriod === 'Custom' ? null : ''" [class.border-danger]="formState.periodDates.invalid" />
                                        </div>
                                        <div class="col-6">
                                            <label class="form-label">&nbsp;</label>
                                            <input type="date" name="planEndDate" class="form-control form-control-sm" [(ngModel)]="roundParameters.periodEndDate" [attr.disabled]="roundParameters.planPeriod === 'Custom' ? null : ''" [class.border-danger]="formState.periodDates.invalid" />
                                        </div>
                                    </div>
                                    <div *ngIf="formState.periodDates.invalid" class="text-danger">
                                        {{formState.periodDates.errorMessage}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="d-block w-100">
                    <div class="float-end">
                        <span *ngIf="showSaveComplete" class="text-success me-2">
                            Copy round was saved successfully
                        </span>
                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 100px;" [disabled]="isAnyLoadInvalid()" (click)="onSaveClick(true)" *ngIf="formStatus == FormStatus.Normal">
                            Save &amp; Close
                        </button>

                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 100px;" [disabled]="isAnyLoadInvalid()" (click)="onSaveClick(false)" *ngIf="formStatus == FormStatus.Normal">
                            Save &amp; New
                        </button>
                        <button type="button" class="btn btn-sm btn-primary me-2" style="width: 100px;" disabled *ngIf="formStatus == FormStatus.Saving">
                            <span class="spinner-border spinner-border-sm me-1"></span>
                            <span>Saving...</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-secondary" style="width: 100px;" data-bs-dismiss="modal" [disabled]="formStatus == FormStatus.Saving">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<load-bank-apply [parameters]="loadBankApplyParameters" [loadBankApplyFormId]="loadBankApplyFormId" (loadBankApply)="applyLoadNumber($event)"></load-bank-apply>